import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/LedgerTypes'

export const attachDocuments = createAction(types.ATTACH_DOCUMENTS)
export const attachDocumentsFailed = createAction(types.ATTACH_DOCUMENTS_FAILED)
export const attachDocumentsSuccess = createAction(types.ATTACH_DOCUMENTS_SUCCEEDED)
export const deleteAttachment = createAction(types.DELETE_ATTACHMENT)
export const deleteAttachmentFailed = createAction(types.DELETE_ATTACHMENT_FAILED)
export const deleteAttachmentSucceeded = createAction(types.DELETE_ATTACHMENT_SUCCEEDED)
export const deleteExpense = createAction(types.DELETE_EXPENSE)
export const deleteExpenseFailed = createAction(types.DELETE_EXPENSE_FAILED)
export const deleteExpenseSucceeded = createAction(types.DELETE_EXPENSE_SUCCEEDED)
export const fetchExpense = createAction(types.FETCH_EXPENSE)
export const fetchExpenseFailed = createAction(types.FETCH_EXPENSE_FAILED)
export const fetchExpenseSucceeded = createAction(types.FETCH_EXPENSE_SUCCEEDED)
export const fetchExpenses = createAction(types.FETCH_EXPENSES)
export const fetchExpensesFailed = createAction(types.FETCH_EXPENSES_FAILED)
export const fetchExpensesSucceeded = createAction(types.FETCH_EXPENSES_SUCCEEDED)
export const setSelectedDocument = createAction(types.SET_SELECTED_DOCUMENT)
export const updateExpense = createAction(types.UPDATE_EXPENSE)
export const updateExpenseFailed = createAction(types.UPDATE_EXPENSE_FAILED)
export const updateExpenseSuccess = createAction(types.UPDATE_EXPENSE_SUCCEEDED)
export const updateFilterString = createAction(types.UPDATE_FILTER_STRING)
export const socketDocumentCreated = createAction(types.SOCKET_DOCUMENT_CREATED)
export const socketDocumentUpdated = createAction(types.SOCKET_DOCUMENT_UPDATED)
export const socketDocumentUpload = createAction(types.SOCKET_DOCUMENT_UPLOAD)
export const fetchDocsWorkflowSearch = createAction(types.FETCH_DOCS_WORKFLOW_SEARCH)
export const fetchDocsWorkflowSearchFailed = createAction(types.FETCH_DOCS_WORKFLOW_SEARCH_FAILED)
export const fetchDocsWorkflowSearchSucceeded = createAction(
  types.FETCH_DOCS_WORKFLOW_SEARCH_SUCCEEDED,
)
